import { CrudFilters } from "../../../../../hooks/useCrudFilters";
import { useTranslation } from "react-i18next";
import { Form, Button } from "react-bootstrap";
import { TruckLicencePlateSelectField } from "../../../truck/modules/commons/TruckLicencePlateSelectField";
import { TableFiltersWrapper } from "../../../../general/table/modules/commons/tableFilters/tableFilters";
import { TableFilters } from "../../../../general/table/modules/commons/tableFilters/tableFilters";
import { TableFilterInputWrapper } from "../../../../general/table/modules/commons/tableFilters/tableFilters";
import { ReactSelectOptionType } from "../../../../../shared/types/reactSelectType";

export const RouteTableFilters = ({
  updateFilter,
  removeFilter,
  getFilter,
  filters,
  resetFilters,
}: CrudFilters) => {
  const { t } = useTranslation("common");

  const dateSearchValue = getFilter("date", "contains") as string;
  const truckSearchValue = getFilter("truck.id", "in") as string;

  return (
    <TableFiltersWrapper>
      <TableFilters>
        <TableFilterInputWrapper md={6}>
          <label>{t("Search")}</label>
          <Form.Control
            type="date"
            placeholder={t("Search by date")}
            value={dateSearchValue ?? ""}
            onChange={(event) => {
              const value = event.target.value;
              if (value === "") {
                removeFilter("date");
              } else {
                updateFilter("date", value, "contains");
              }
            }}
          />
        </TableFilterInputWrapper>

        <TableFilterInputWrapper md={6}>
          <label>{t("Truck")}</label>
          <TruckLicencePlateSelectField
            onChange={(options: unknown) => {
              const selectedOptions = options as ReactSelectOptionType[];

              if (options === null || selectedOptions.length === 0) {
                removeFilter("truck.id");
                return;
              }

              const selectedOptionsStringArray = selectedOptions.map(
                (option) => option.value,
              );

              updateFilter("truck.id", selectedOptionsStringArray, "in");
            }}
            value={truckSearchValue}
          />
        </TableFilterInputWrapper>
      </TableFilters>

      {filters?.fields && Object.keys(filters.fields).length > 0 && (
        <Button
          onClick={resetFilters}
          size={"sm"}
          className="reset-filters"
          variant="light"
        >
          {t("Reset filters")}
        </Button>
      )}
    </TableFiltersWrapper>
  );
};
